import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, FileTextIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-[#0B1F17] to-[#102A1F] py-4 md:py-6 px-3 relative overflow-hidden border-b-2 border-[#D4A843]" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-66">
        <h1 className="text-2xl md:text-4xl font-black text-white leading-tight mb-2 uppercase tracking-tight" data-id="element-67">
          🌲 TODO TU SISTEMA DE PRODUCCIÓN FORESTAL{' '}
          <span className="text-[#D4A843]" data-id="element-68">RESUELTO</span>
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 w-full max-w-lg relative" onClick={scrollToPricing} data-id="element-69">
          <div className="absolute inset-0 bg-[#74C69D] opacity-20 blur-2xl rounded-full" data-id="element-70"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5KAYaKgs4sLgt1mMc6WJLY/mockups_PRODUCCION_FORESTAL.png" alt="Kit Completo Producción Forestal" className="w-full h-auto drop-shadow-2xl relative z-10 glow-green rounded-xl" data-id="element-71" />
        </div>

        <p className="text-[#BFC9C5] text-sm md:text-base font-bold mb-2 max-w-xl mx-auto leading-snug" data-id="element-72">
          Clases, contenidos, prácticas y procesos forestales ya armados para
          que dejes de improvisar.
        </p>

        <div className="bg-[#102A1F] border border-[#D4A843] rounded-lg px-4 py-2 mb-3 inline-block shadow-lg" data-id="element-73">
          <p className="text-white font-black text-sm md:text-base" data-id="element-74">
            👉 Llegás al aula sabiendo exactamente qué enseñar.
          </p>
        </div>

        <div className="flex items-center justify-center gap-4 md:gap-6 mb-3 flex-nowrap" data-id="element-75">
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-76">
            <FileTextIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={2.5} data-id="element-77" />
            PDF
          </div>
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-78">
            <ZapIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={2.5} data-id="element-79" />
            ACCESO INMEDIATO
          </div>
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-80">
            <BookOpenIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={2.5} data-id="element-81" />
            CURRÍCULA ARGENTINA
          </div>
        </div>

        <div className="flex justify-center mb-3 w-full max-w-sm" data-id="element-82">
          <CTAButton variant="primary" fullWidth className="py-3 text-sm md:text-base" data-id="element-83">
            SÍ, QUIERO MIS CLASES RESUELTAS
          </CTAButton>
        </div>

        <div className="flex items-center justify-center gap-3 md:gap-5 text-[#BFC9C5] text-[10px] md:text-xs font-bold mb-3 flex-nowrap" data-id="element-84">
          
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-85">
            <LockIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-86" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-87">
            <CreditCardIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-88" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="inline-block bg-[#0F241C] border border-[#1F3D2B] rounded-full px-3 py-1.5 shadow-inner" data-id="element-89">
          <p className="text-[#BFC9C5] text-[10px] md:text-xs font-bold flex items-center gap-1.5" data-id="element-90">
            <span className="text-[#D4A843] text-sm tracking-widest" data-id="element-91">
              ★★★★★
            </span>
            Más de 300 docentes ya tienen sus clases resueltas con este sistema
          </p>
        </div>
      </div>
    </section>;
}